<template>
	<div class="container">
		<triangle-image
			title="Invita i tuoi amici a cena!"
		/>
		<div class="content">
			<section class="section-login">
				<h3>
					<b>Regala <nobr>{{ invitedAmound * invitedCount }} €</nobr> per i loro primi due ordini e ottieni <nobr>{{ rewardAmount * rewardCount }} €</nobr> per le tue cene</b>
				</h3>

				<template v-if="!user">
					<p>Invita i tuoi amici su Quomi tramite email o condividi il tuo codice di invito sui canali che preferisci (Messenger, Whatsapp, Social).</p>
					<p>Per ogni amico che inviti e che effettua un ordine, riceverai {{rewardCount}} buoni sconto del valore di <nobr>{{ rewardAmount }} €</nobr>!</p>
					<p><b>Non c’è limite al numero di inviti che puoi inviare!</b></p>
					<p>I tuoi crediti disponibili appaiono automaticamente nella pagina del tuo profilo.</p>

					<CTA
						:content="`Accedi per invitare i tuoi amici`"
						:color="`orange`"
						@click="openModal('signin')"
						isArrow
					/>

					<a @click="openModal('signup')" title="Registrati">
						<div class="reg">
							Non hai ancora un account? Registrati ed effettua il primo ordine.
						</div>
					</a>
				</template>

				<template v-if="user">
					<router-link
						:to="{name: 'profile_invite-friend'}"
						title="Profilo"
					>
						<CTA
							:content="`Vai al mio profilo`"
							:color="`orange`"
							isArrow
						/>
					</router-link>
					<h3>Invita un amico ora!</h3>

				</template>
				<p>
					<router-link
						:to="{name: 'legal-referral'}"
						class="link-detail"
						v-html="`Termini e condizioni degli inviti`"
					/>
				</p>
			</section>
		</div>
	</div>
</template>

<script>

import TriangleImage from './TriangleImage'

import { configStore } from '../store/configStore' 

export default {
	components: {
		TriangleImage
	},

	data () {
		return {
			configStore: configStore.state,
		}
	},

	computed: {
		user () {
			return this.$root.user
		},

		rewardAmount () {
			return this.configStore.config && this.configStore.config['quomi.refer.reward_amount']
				? this.configStore.config['quomi.refer.reward_amount']
				: this.configStore.default.reward_amount
		},

		invitedAmound () {
			return this.configStore.config && this.configStore.config['quomi.refer.invited_amount']
				? this.configStore.config['quomi.refer.invited_amount']
				: this.configStore.default.invited_amount
		},

		rewardCount () {
			return this.configStore.config && this.configStore.config['quomi.refer.reward_count']
				? this.configStore.config['quomi.refer.reward_count']
				: this.configStore.default.reward_amount
		},

		invitedCount () {
			return this.configStore.config && this.configStore.config['quomi.refer.invited_count']
				? this.configStore.config['quomi.refer.invited_count']
				: this.configStore.default.invited_amount
		},

	},

	methods: {
		openModal (target) {
			this.$emit('openModal', target)
		}
	},

	mounted () {
		configStore.loadConfig()
	}
}

</script>

<style scoped>
	.triangle-image {
		background-image: url("../assets/img/covers/invite-friend.jpg");
		background-position: center 40%;
	}

	h3 {
		margin: 20px auto;
		line-height: 1.5;
		text-align: left;
	}

	.reg {
		color: #399ec9;
		font-size: 20px;
		border-bottom: 0px solid;
		margin: 30px 0;
		white-space: normal;
	}

	.reg:hover {
		cursor: pointer;
	}

	.section-login {
		max-width: 900px;
		text-align: left;
		margin: 0px auto;
	}
</style>
